﻿export interface SearchOptions {
    searchOptions: {
        filter?: string;
        size?: number;
        skip?: number;
        includeTotalCount?: boolean;
    };
    Select?: string[];
    OrderBy?: string[];
    Facets?: string[];
    EUMSearchSources?: string[];
    highlightFields?: string[];
}

export interface SearchResult<T = Record<string, unknown>> {
    totalCount: number;
    value: Array<{ document: T }>;
    facets?: Record<string, Array<{ value: unknown; count: number }>>;
}

class SearchService {
    private static instance: SearchService;
    private bearerToken: string | null = null;

    static getInstance(): SearchService {
        if (!SearchService.instance) {
            SearchService.instance = new SearchService();
        }
        return SearchService.instance;
    }

    setToken(token: string): void {
        this.bearerToken = token;
    }

    async search<T = Record<string, unknown>>(
        url: string,
        searchText: string,
        options: SearchOptions
    ): Promise<SearchResult<T>> {
        const headers: Record<string, string> = {
            'Content-Type': 'application/json; charset=utf-8',
        };
        if (this.bearerToken) {
            headers['Authorization'] = this.bearerToken;
        }

        const response = await fetch(url + encodeURIComponent(searchText), {
            method: 'POST',
            headers,
            body: JSON.stringify(options),
        });

        if (!response.ok) {
            throw new Error(`Search failed: ${response.status}`);
        }
        return response.json();
    }

    async searchCSV(
        url: string,
        searchText: string,
        options: SearchOptions
    ): Promise<Response> {
        const headers: Record<string, string> = {
            'Content-Type': 'application/json; charset=utf-8',
            'Accept': 'text/csv',
        };
        if (this.bearerToken) {
            headers['Authorization'] = this.bearerToken;
        }

        const response = await fetch(url + encodeURIComponent(searchText), {
            method: 'POST',
            headers,
            body: JSON.stringify(options),
        });

        if (!response.ok) {
            throw new Error(`Search failed: ${response.status}`);
        }
        return response;
    }

    async htmlToPDF(
      html: string
    ): Promise<Response> {
      const headers: Record<string, string> = {
        'Content-Type': 'application/json; charset=utf-8',
      };
      if (this.bearerToken) {
        headers['Authorization'] = this.bearerToken;
      }
      const response = await fetch('/api/Portal/HtmlToPDF', {
        method: 'POST',
        headers,
        body: JSON.stringify({
          bodyHtmlContent: html
        })
      });

      if (!response.ok) {
        throw new Error(`Search failed: ${response.status}`);
      }
      return response;
    }
}

export const searchService = SearchService.getInstance();